import React, { FC, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useTheme } from '@material-ui/core';
import { Feature } from './apis/model-results/models';
import DiscoveryItemCard from './DiscoveryItemCard';
import { useStyles } from './styles/globals';
import { eventConfig, stringify } from './utils/config';

export interface FeatureCardProps {
  feature: Feature;
  defaultExpanded?: boolean;
}

const FeatureCard: FC<FeatureCardProps> = ({
  feature: { event, speaker_name, content, suggestion, discovery_items, timestamp },
  defaultExpanded,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const [expanded, setExpanded] = useState(Boolean(defaultExpanded));
  if (!eventConfig[event]) return null;
  const { color, displayParticipant } = eventConfig[event];
  const borderColor = color;
  const title =
    stringify(event) + (displayParticipant && speaker_name ? ` by ${speaker_name}` : '');

  return (
    <div
      onClick={!defaultExpanded ? () => setExpanded(!expanded) : undefined}
      className={classes.appCard}
      style={{ borderColor }}
    >
      {/* {expanded && timestamp && (
        <span className={classes.appChip} style={{ borderColor, backgroundColor }}>
          {moment(timestamp).fromNow()}
        </span>
      )} */}
      <div className={classes.appRow}>
        {/* {image && <img src={image} width={image_size} height={image_size} />} */}
        <span className={classes.appText} style={{ fontSize: 14, textAlign: 'center' }}>
          <b>{title}</b>
        </span>
      </div>
      {expanded && content && (
        <span className={classes.appText} style={{ fontSize: 14 }}>
          {content}
        </span>
      )}
      {expanded && suggestion && (
        <span className={classes.appText} style={{ color: theme.palette.text.secondary }}>
          {suggestion}
        </span>
      )}
      {expanded &&
        discovery_items
          ?.filter((item) => !item.covered)
          .sort((a, b) => b.importance - a.importance)
          .slice(0, 3)
          .map((item) => <DiscoveryItemCard key={item.question} item={item} />)}
      {expanded &&
        discovery_items
          ?.filter((item) => item.covered)
          .sort((a, b) => b.importance - a.importance)
          .map((item) => <DiscoveryItemCard key={item.question} item={item} />)}
      {!defaultExpanded && (
        <div className={classes.appRow}>{expanded ? <FaChevronUp /> : <FaChevronDown />}</div>
      )}
    </div>
  );
};

export default FeatureCard;
